@let creditNote = supplierCreditNote();
@let extraCosts = (creditNote?.customFees ?? 0) + (creditNote?.transport ?? 0);
<div class="d-flex flex-column w-100 totals-content">
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "NET" | translate | capitalize }}</div>
    <div class="d-flex justify-content-end">
      <rc-value-mismatch
        [value]="creditNote?.netTotal"
        [calculatedValue]="calculatedNetTotal()"
        [label]="'NET'"
        [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'NET' | translate }" />
      <div class="g-col-6 price-col">{{ creditNote?.netTotal ?? 0 | kendoNumber: decimalFormat }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-between total-item indent">
    <div class="g-col-6 label-col">{{ "GOODS" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ creditNote?.netTotalItems ?? 0 | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="d-flex justify-content-between total-item indent">
    <div class="g-col-6 label-col">{{ "TAXES" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ creditNote?.netTotalTax ?? 0 | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="d-flex justify-content-between total-item indent">
    <div class="g-col-6 label-col">{{ "EXTRA_COSTS" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ extraCosts | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "PAYMENT_DISCOUNT" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ creditNote?.paymentDiscountPercentage ?? 0 }}%</div>
  </div>
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "TAX_BASE" | translate | capitalize }}</div>
    <div class="d-flex justify-content-end">
      <rc-value-mismatch
        [value]="creditNote?.taxableTotal"
        [calculatedValue]="calculatedTaxBase()"
        [label]="'TAX_BASE'"
        [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'TAX_BASE' | translate }" />
      <div class="g-col-6 price-col">{{ creditNote?.taxableTotal ?? 0 | kendoNumber: decimalFormat }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-between total-item">
    <div class="g-col-6 label-col">{{ "VAT" | translate | capitalize }}</div>
    <div class="g-col-6 price-col">{{ creditNote?.vatTotal ?? 0 | kendoNumber: decimalFormat }}</div>
  </div>
  <div class="totals-group">
    <div class="d-flex justify-content-between totals" #wrapper>
      <div rcSelectableOverflow [wrapperElement]="wrapper" class="label-col">{{ "TOTAL" | translate | capitalize }}</div>
      <div class="d-flex justify-content-end">
        <rc-value-mismatch
          [value]="creditNote?.total"
          [calculatedValue]="calculatedTotal()"
          [label]="'TOTAL'"
          [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'TOTAL' | translate }" />
        <span class="prefix">{{ "EUR" | translate | uppercase }}</span>
        <span class="price-col">{{ creditNote?.total ?? 0 | kendoNumber: decimalFormat }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between total-item" #wrapper>
      <div rcSelectableOverflow [wrapperElement]="wrapper" class="label-col">{{ "PAYMENT_DISCOUNT" | translate | capitalize }}</div>
      <div class="d-flex justify-content-end">
        <rc-value-mismatch
          [value]="creditNote?.paymentDiscountAmount"
          [calculatedValue]="calculatedPaymentDiscount()"
          [label]="'PAYMENT_DISCOUNT'"
          [calculatedLabel]="'CALCULATED_ENTITY' | translate: { entity: 'PAYMENT_DISCOUNT' | translate }" />
        <span class="prefix">{{ "EUR" | translate | uppercase }}</span>
        <span class="price-col">{{ creditNote?.paymentDiscountAmount ?? 0 | kendoNumber: decimalFormat }}</span>
      </div>
    </div>
  </div>
</div>
